import main from "./litter.svg"
import addNew from "./litter_add_new.svg"

const litters = {
  main,
  addNew,
}
export default litters
